export const PAGINATION_PAGE_NUMBER = 10;
export const ALLOWED_IN_PENSION = [
    "abdur-rahmaan.oreagba@chrome-architecture.com",
    "david.akinpelu@chrome-architecture.com",
    "esther.akinfe@chrome-architecture.com",
    "ihejiofor.george@chrome-architecture.com",
    "hr@chrome-architecture.com",
    "adejinmi.odunayo@chrome-architecture.com",
    "olabanji.edunjobi@chrome-architecture.com",
    "samuel.johnson@chrome-architecture.com",
    "awojobi.tobi@chrome-architecture.com",
    "victor.kolapo@chrome-architecture.com",
    "it@chrome-architecture.com",
];
export const MAXIMUM_LEAVE_ALLOWED = "14";
export const STATUS = [
    "Pending",
    "Approved",
    "Rejected",
    // "Paid",
];
export const COMPANY_NAME = "Chrome Architecture Limited";
export const EXPENSE_CATEGORIES = [
    // "All Categories",
    "Accommodation",
    "Equipment / Materials",
    "Fuel / Diesel",
    "Maintenance",
    "Medical / Welfare",
    "Project Expense",
    "Salary",
    "Transportation",
    "Other",
];
export const PROJECT_REPORT_CATEGORY = [
    "Daily Report",
    "Weekly Report",
    "Monthly Report",
    "General Report",
    "Incident Report",
    "Lesson Report",
    "Safety Report",
    "Site Inspection",
    "Site Meeting Report",
    "Technical Report",
    "Work Completion",
]